
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerEditor("Matrix.Rebalancer.InstructionTaskMapGrid", [Serenity.IReadOnly])
    @Serenity.Decorators.element("<div/>")
    export class InstructionTaskMapGrid extends SiteEntityGrid<InstructionTaskMapRow, any>
        implements Serenity.IReadOnly {
        protected getColumnsKey() { return 'Rebalancer.InstructionTaskMap'; }
        protected getDialogType() { return InstructionTaskMapDialog; }
        protected getIdProperty() { return InstructionTaskMapRow.idProperty; }
        protected getLocalTextPrefix() { return InstructionTaskMapRow.localTextPrefix; }
        protected getService() { return InstructionTaskMapService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        private _readOnly: boolean;

        get_readOnly(): boolean {
            return !!this._readOnly;
        }

        set_readOnly(value: boolean): void {
            if (!!this._readOnly !== !!value) {
                this._readOnly = !!value;
                this.updateInterface();
            }
        }

        protected updateInterface() {
            this.toolbar.findButton('add-button').toggle(!this._readOnly && !!this._taskTypeCode);
        }

        private _taskTypeCode: string;

        public set taskTypeCode(value: string) {
            if (this._taskTypeCode !== value) {
                this._taskTypeCode = value;
                this.setEquality(InstructionTaskMapRow.Fields.TaskTypeCode, value);
                this.refresh();
            }
        }

        protected addButtonClick() {
            this.editItem(<InstructionTaskMapRow>{
                TaskTypeCode: this._taskTypeCode
            });
        }

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._taskTypeCode;
        }
    }
}